import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=471a66ab&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=ts&"
export * from "./preview.vue?vue&type=script&lang=ts&"
import style0 from "./preview.vue?vue&type=style&index=0&id=471a66ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a66ab",
  null
  
)

export default component.exports